module.exports = __webpack_public_path__ + "img/WalkerGreen.ffca75a1.svg";